import { memo } from "react";
import { PROJECTILE_RADIUS } from "./constants";
import { Box } from "./react-graphics";

type Props = {
  x: number;
  y: number;
};

const WIDTH = 2 * PROJECTILE_RADIUS;
const HEIGHT = 2 * PROJECTILE_RADIUS;

const EnemyProjectile = ({ x, y }: Props) => {
  return (
    <Box
      x={x}
      y={-y}
      width={WIDTH}
      height={HEIGHT}
      fillColor={0x000000}
      pivotX={0.5}
      pivotY={0.5}
    />
  );
};

export default memo(EnemyProjectile);
